import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  addFeedbacks,
  addOdemeUyumsuzlukTaleps,
  getMemberFeks,
  getSubmitDemandOptions,
  selectWorkflow,
  clearMemberFek,
  getMemberIbans,
  clearMemberIban,
  clearSuccessMessage,
} from "../../../state/ducks/workflow/index";
import { getMemberNumber } from "../../../state/ducks/member/index";
import $ from "jquery";
import KvkkModal from "../shared/KvkkModal";
import EminevimLoading from "../shared/EminevimLoading";
import LoginPageAlert from "../Login/LoginPageAlert";
import AppCustomSelect from "../shared/AppCustomSelect";
import {
  getCustomSelectLabel,
  getCustomSelectValue,
  setCustomSelectFieldState,
} from "../../../utils/customSelect";
import { extractApiErrorMessage } from "../../../utilities/apiErrorMessage";

const MISSING_PAYMENT_REASON = "8";
const BANK_INFO_URL = "https://www.eminevim.com/banka-hesap-numaralarimiz";
const DESCRIPTION_MAX_LENGTH = 500;
const DEKONT_MAX_BYTES = 10 * 1024 * 1024;
const DEKONT_ALLOWED_EXTENSIONS = ["pdf", "jpg", "jpeg", "png"];
const DEKONT_ALLOWED_TYPES = ["application/pdf", "image/jpeg", "image/png"];

const getTodayDateInputValue = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const STANDARD_DEMAND_STEPS = [
  { key: "reason", label: "Başvuru Nedeni" },
  { key: "info", label: "Bilgiler" },
  { key: "result", label: "Oluştur" },
];

const MISSING_PAYMENT_STEPS = [
  { key: "reason", label: "Başvuru Nedeni" },
  { key: "type", label: "Başvuru Türü" },
  { key: "info", label: "Bilgiler" },
  { key: "result", label: "Oluştur" },
];

const BASVURU_TURU_OPTIONS = [
  {
    value: "1",
    enumName: "YanlisUyelikOdeme",
    displayName: "Yanlış Üyeliklere Yapılan Ödeme",
    title: "Yanlış üyeliğime ödeme yaptım",
    hint: "Ödemenizi yanlış bir üyeliğe yaptığınızı düşünüyorsanız bu seçeneği seçin.",
    iconClass: "t-icon-clock",
  },
  {
    value: "2",
    enumName: "HesabaGecmeyenOdeme",
    displayName: "Hesaba Geçmeyen Ödeme",
    title: "Gün içinde yaptığım ödeme üyeliğime yansımadı",
    hint: "Gün içinde yaptığınız ödemenin henüz üyeliğinize yansımadığını düşünüyorsanız bu seçeneği seçin.",
    iconClass: "t-icon-wallet",
  },
];

const isMissingPaymentReason = (reason) => reason === MISSING_PAYMENT_REASON;

const getDemandSteps = (reason) =>
  isMissingPaymentReason(reason) ? MISSING_PAYMENT_STEPS : STANDARD_DEMAND_STEPS;

const getReasonLabel = (reason, options) =>
  (options || []).find((option) => option.value === reason)?.label || "";

const getMemberOptionValue = (item) =>
  String(item?.id ?? item?.Id ?? "");

const getMemberOptionLabel = (item) =>
  String(item?.adi ?? item?.Adi ?? item?.id ?? item?.Id ?? "");

const toMemberSelectOptions = (numbers) => {
  if (!Array.isArray(numbers)) {
    return [];
  }

  return numbers
    .map((item) => ({
      value: getMemberOptionValue(item),
      label: getMemberOptionLabel(item),
    }))
    .filter((option) => option.value && option.value !== "0");
};

const getDekontExtension = (fileName) => {
  const parts = String(fileName || "").toLowerCase().split(".");
  return parts.length > 1 ? parts[parts.length - 1] : "";
};

const toAlertMessages = (message) => {
  if (message == null || message === "") {
    return [];
  }

  if (Array.isArray(message)) {
    return message.reduce((acc, item) => acc.concat(toAlertMessages(item)), []).filter(Boolean);
  }

  const text = extractApiErrorMessage(message, "");
  return text ? [text] : [];
};

const isAllowedDekontFile = (file) => {
  if (!file) {
    return false;
  }

  const extension = getDekontExtension(file.name);
  const hasAllowedExtension = DEKONT_ALLOWED_EXTENSIONS.includes(extension);
  const hasAllowedType = !file.type || DEKONT_ALLOWED_TYPES.includes(file.type);
  return hasAllowedExtension && hasAllowedType;
};

const renderDemandSteps = (activeStep, steps) => (
  <div className="t-controlContactInfo-steps t-createPayment-steps">
    {steps.map((step, index) => (
      <React.Fragment key={step.key}>
        <div
          className={`t-controlContactInfo-step${
            index === activeStep ? " t-controlContactInfo-step--active" : ""
          }${index < activeStep ? " t-controlContactInfo-step--completed" : ""}`}
        >
          <span className="t-controlContactInfo-stepNumber">{index + 1}</span>
          <span className="t-controlContactInfo-stepLabel">{step.label}</span>
        </div>
        {index < steps.length - 1 && (
          <div className="t-controlContactInfo-stepLine" aria-hidden="true" />
        )}
      </React.Fragment>
    ))}
  </div>
);

function oneriFormKontrol(reasonLabel) {
  var konu = $("#konu").val();
  var mesaj = $("#mesaj").val();
  var selectTalep = reasonLabel || "Seçiniz";
  var selectUyeNo = getCustomSelectLabel("uyeNo");
  var selectUyeNoIban = getCustomSelectLabel("uyeNoIban");
  var selectedSaticiTuru = getCustomSelectLabel("saticiTuru");

  var adiSoyadi = $("#adiSoyadi").val();
  var tckn = $("#tckn").val();
  var babaAdi = $("#babaAdi").val();

  var unvan = $("#unvan").val();
  var vkn = $("#vkn").val();
  var mersisNo = $("#mersisNo").val();

  var iban = $("#iban").val();
  var phone = $("#phone").val();

  var durum = 1;

  if (selectTalep == "Seçiniz") {
    durum = 0;
  }

  if (selectTalep == "Araç Rehin Fek" || selectTalep == "Konut İpotek Fek") {
    if (document.getElementById("uyeNo") && (["", "0"].includes(getCustomSelectValue("uyeNo")) || selectUyeNo == "Seçiniz")) {
      durum = 0;
      setCustomSelectFieldState("uyeNo", true);
      $("#uyeNo_hatamesaj").html("Üyelik bilgisi boş bırakılamaz");
    } else if (document.getElementById("uyeNo")) {
      setCustomSelectFieldState("uyeNo", false);
      $("#uyeNo_hatamesaj").html("");
    }
  }

  if (selectTalep == "Satıcı IBAN Girişi") {
    if (selectedSaticiTuru == "Seçiniz") {
      durum = 0;
      setCustomSelectFieldState("saticiTuru", true);
      $("#saticiTuru_hatamesaj").html("Satıcı Türü boş bırakılamaz");
    } else {
      setCustomSelectFieldState("saticiTuru", false);
      $("#saticiTuru_hatamesaj").html("");
    }

    if (selectUyeNoIban == "Seçiniz") {
      durum = 0;
      setCustomSelectFieldState("uyeNoIban", true);
      $("#uyeNoIban_hatamesaj").html("Uyelik bilgisi boş bırakılamaz");
    } else {
      setCustomSelectFieldState("uyeNoIban", false);
      $("#uyeNoIban_hatamesaj").html("");
    }

    if (selectedSaticiTuru == "Bireysel") {


      if (adiSoyadi == "") {
        durum = 0; // Konu Boş
        $("#adiSoyadi").parent().addClass("t-error");
        $("#adiSoyadi").next().html("<i class='t-icon-error text-danger'></i>");
        $("#adiSoyadi_hatamesaj").html("Satıcı Adı Soyadı alanı boş bırakılamaz");
      } else {
        $("#adiSoyadi").parent().removeClass("t-error");
        $("#adiSoyadi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#adiSoyadi_hatamesaj").html("");
      }


      if (tckn == "") {
        durum = 0; // Konu Boş
        $("#tckn").parent().addClass("t-error");
        $("#tckn").next().html("<i class='t-icon-error text-danger'></i>");
        $("#tckn_hatamesaj").html("Satıcı TCKN alanı boş bırakılamaz");
      } else {
        $("#tckn").parent().removeClass("t-error");
        $("#tckn").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#tckn_hatamesaj").html("");
      }

      if (babaAdi == "") {
        durum = 0; // Konu Boş
        $("#babaAdi").parent().addClass("t-error");
        $("#babaAdi").next().html("<i class='t-icon-error text-danger'></i>");
        $("#babaAdi_hatamesaj").html("Satıcı Baba Adı alanı boş bırakılamaz");
      } else {
        $("#babaAdi").parent().removeClass("t-error");
        $("#babaAdi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#babaAdi_hatamesaj").html("");
      }
    }

    if (selectedSaticiTuru == "Kurumsal") {



      if (unvan == "") {
        durum = 0; // Konu Boş
        $("#unvan").parent().addClass("t-error");
        $("#unvan").next().html("<i class='t-icon-error text-danger'></i>");
        $("#unvan_hatamesaj").html("Satıcı Ünvan alanı boş bırakılamaz");
      } else {
        $("#unvan").parent().removeClass("t-error");
        $("#unvan").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#unvan_hatamesaj").html("");
      }


      if (vkn == "") {
        durum = 0; // Konu Boş
        $("#vkn").parent().addClass("t-error");
        $("#vkn").next().html("<i class='t-icon-error text-danger'></i>");
        $("#vkn_hatamesaj").html("Satıcı VKN alanı boş bırakılamaz");
      } else {
        $("#vkn").parent().removeClass("t-error");
        $("#vkn").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#vkn_hatamesaj").html("");
      }
    }

    if (phone == "") {
      durum = 0; // Konu Boş
      $("#phone").parent().addClass("t-error");
      $("#phone").next().html("<i class='t-icon-error text-danger'></i>");
      $("#phone_hatamesaj").html("Satıcı Telefon Numarası alanı boş bırakılamaz");
    } else {
      $("#phone").parent().removeClass("t-error");
      $("#phone").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#phone_hatamesaj").html("");
    }

    iban = iban.replace(/\s/g, "");
    const ibanRegex = /^TR[0-9]{24}$/;
    if (!ibanRegex.test(iban)) {
      durum = 0; // Konu Boş
      $("#iban").parent().addClass("t-error");
      $("#iban").next().html("<i class='t-icon-error text-danger'></i>");
      $("#iban_hatamesaj").html("Satıcı IBAN alanını geçerli bir değer giriniz");
    } else if (iban == "") {
      durum = 0; // Konu Boş
      $("#iban").parent().addClass("t-error");
      $("#iban").next().html("<i class='t-icon-error text-danger'></i>");
      $("#iban_hatamesaj").html("Satıcı IBAN alanı boş bırakılamaz");
    } else {
      $("#iban").parent().removeClass("t-error");
      $("#iban").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#iban_hatamesaj").html("");
    }

  } else {

  }

  // konu boş mu kontrol
  if (konu == "") {
    durum = 0; // Konu Boş
    $("#konu").parent().addClass("t-error");
    $("#konu").next().html("<i class='t-icon-error text-danger'></i>");
    $("#konu_hatamesaj").html("Konu alanı boş bırakılamaz");
  } else {
    $("#konu").parent().removeClass("t-error");
    $("#konu").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#konu_hatamesaj").html("");
  }
  // Açıklama boş mu kontrol
  if (mesaj == "" && selectTalep != "Satıcı IBAN Girişi") {
    durum = 0; // Mesaj Boş
    $("#mesaj").parent().addClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-error text-danger'></i>");
    $("#mesaj_hatamesaj").html("Mesaj alanı boş bırakılamaz");
  } else {
    $("#mesaj").parent().removeClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#mesaj_hatamesaj").html("");
  };
  return durum;
}

export class SubmitDemand extends Component {
  state = {
    subject: "",
    description: "",
    reason: "0",
    currentStep: 0,
    reasonError: "",
    memberNo: "0",
    memberFekList: [],
    isSubjectReadonly: true,
    kvkkMetni: "",
    isKvkkModalOpen: false,
    memberIbanList: [],

    nameSurname: "",
    tckn: "",
    fatherName: "",

    unvan: "",
    vkn: "",
    mersisNo: "",

    iban: "",
    phone: "",

    saticiTuru: "0",
    shouldAnimateCard: false,
    isProcessing: false,
    kvkkAccepted: false,
    formErrors: {
      kvkk: "",
      wrongPaidMemberNo: "",
      targetMemberNo: "",
      paidMemberNo: "",
      dekont: "",
      paymentDate: "",
      paymentAmount: "",
    },
    formAlert: null,
    applicationType: "",
    wrongPaidMemberNo: "0",
    targetMemberNo: "0",
    paidMemberNo: "0",
    dekontFile: null,
    dekontDragOver: false,
    missingPaymentConfirmed: false,
    paymentDate: "",
    paymentAmount: "",
  };

  dekontInputRef = React.createRef();

  getEmptyFormErrors = () => ({
    kvkk: "",
    wrongPaidMemberNo: "",
    targetMemberNo: "",
    paidMemberNo: "",
    dekont: "",
    paymentDate: "",
    paymentAmount: "",
  });

  getMissingPaymentInfoReset = () => ({
    wrongPaidMemberNo: "0",
    targetMemberNo: "0",
    paidMemberNo: "0",
    dekontFile: null,
    dekontDragOver: false,
    missingPaymentConfirmed: false,
    paymentDate: "",
    paymentAmount: "",
    description: "",
    formErrors: this.getEmptyFormErrors(),
    formAlert: null,
  });

  getMissingPaymentReset = () => ({
    applicationType: "",
    ...this.getMissingPaymentInfoReset(),
  });

  scrollToFormTop = () => {
    if (typeof document === "undefined") {
      return;
    }

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    window.requestAnimationFrame(() => {
      const page = document.querySelector(".t-submitDemand-page");
      const content = document.querySelector(".t-sagicerik");

      if (content) {
        content.scrollTop = 0;
      }

      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      if (page?.scrollIntoView) {
        page.scrollIntoView({ behavior: "auto", block: "start" });
      }
    });
  };
  getTalepOptions = () => this.props.submitDemandOptions || [];

  getReasonLabelForState = (reason = this.state.reason) =>
    getReasonLabel(reason, this.getTalepOptions());

  componentDidMount() {
    this.setState({ memberNo: "0", saticiTuru: "0", shouldAnimateCard: true, currentStep: 0 });
    this.props.clearMemberFek();
    this.props.clearMemberIban();
    this.props.getSubmitDemandOptions();
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }
  componentWillUnmount() {
    if (this.redirectTimeout) {
      window.clearTimeout(this.redirectTimeout);
    }
  }

  handleReasonChange = (value) => {
    const selectTalep = getReasonLabel(value, this.getTalepOptions());
    this.setState({
      reason: value,
      saticiTuru: "0",
      reasonError: "",
    });

    if (value === "5" || value === "6") {
      this.setState({
        memberNo: "0",
        subject: selectTalep,
        isSubjectReadonly: true,
        ...this.getMissingPaymentReset(),
      });
      this.props.clearMemberFek();
      this.props.clearMemberIban();
    } else if (value === "7") {
      this.setState({
        memberNo: "0",
        subject: selectTalep,
        isSubjectReadonly: true,
        ...this.getMissingPaymentReset(),
      });
      this.props.clearMemberFek();
      this.props.clearMemberIban();
    } else if (isMissingPaymentReason(value)) {
      this.setState({
        memberNo: "0",
        subject: selectTalep,
        isSubjectReadonly: true,
        ...this.getMissingPaymentReset(),
      });
      this.props.clearMemberFek();
      this.props.clearMemberIban();
      this.props.getMemberNumber();
    } else {
      this.setState({
        memberNo: "0",
        subject: "",
        isSubjectReadonly: false,
        ...this.getMissingPaymentReset(),
      });
      this.props.clearMemberFek();
      this.props.clearMemberIban();
    }
  };

  getDemandSteps = () => getDemandSteps(this.state.reason);

  getResultStepIndex = () => this.getDemandSteps().length - 1;

  getInfoStepIndex = () => (isMissingPaymentReason(this.state.reason) ? 2 : 1);

  isTypeStep = () => isMissingPaymentReason(this.state.reason) && this.state.currentStep === 1;

  isInfoStep = () => this.state.currentStep === this.getInfoStepIndex();

  isResultStep = () => this.state.currentStep === this.getResultStepIndex();

  goToReasonStep = () => {
    this.setState({
      currentStep: 0,
      reasonError: "",
      formAlert: null,
      formErrors: this.getEmptyFormErrors(),
      kvkkAccepted: false,
      ...(isMissingPaymentReason(this.state.reason) ? this.getMissingPaymentReset() : {}),
    });
  };

  goToTypeStep = () => {
    this.setState({
      currentStep: 1,
      reasonError: "",
      formAlert: null,
      ...(isMissingPaymentReason(this.state.reason) ? this.getMissingPaymentInfoReset() : {}),
    });
  };

  goToInfoStep = async () => {
    const { reason } = this.state;
    const { isLoading } = this.props;

    if (!reason || reason === "0") {
      this.setState({ reasonError: "Başvuru nedeni boş bırakılamaz" });
      return;
    }

    if (isLoading) {
      return;
    }

    if (reason === "5" || reason === "6") {
      this.setState({ reasonError: "" });
      const memberFek = await this.props.getMemberFeks(reason);
      const memberFekList = Array.isArray(memberFek) ? memberFek : [];

      if (memberFekList.length === 0) {
        this.setState({
          reasonError: "Üyelik bulunamadı. Araç Rehin Fek ya da Konut İpotek Fek talebi açılamaz.",
        });
        return;
      }

      this.setState({ currentStep: 1, reasonError: "" });
      return;
    }

    if (reason === "7") {
      this.setState({ reasonError: "" });
      const memberIban = await this.props.getMemberIbans();
      const memberIbanList = Array.isArray(memberIban) ? memberIban : [];

      if (memberIbanList.length === 0) {
        this.setState({
          reasonError: "Üyelik bulunamadı. Satıcı IBAN Girişi talebi açılamaz.",
        });
        return;
      }

      this.setState({ currentStep: 1, reasonError: "" });
      return;
    }

    if (isMissingPaymentReason(reason)) {
      this.goToTypeStep();
      return;
    }

    this.setState({ currentStep: 1, reasonError: "" });
  };

  selectApplicationType = (value) => {
    const typeChanged = this.state.applicationType !== value;
    this.setState({
      applicationType: value,
      reasonError: "",
      ...(typeChanged
        ? {
            wrongPaidMemberNo: "0",
            targetMemberNo: "0",
            paidMemberNo: "0",
            dekontFile: null,
            dekontDragOver: false,
            missingPaymentConfirmed: false,
            formErrors: {
              kvkk: "",
              wrongPaidMemberNo: "",
              targetMemberNo: "",
              paidMemberNo: "",
              dekont: "",
              paymentDate: "",
              paymentAmount: "",
            },
          }
        : {}),
    });
  };

  goToMissingPaymentInfoStep = () => {
    if (!this.state.applicationType) {
      this.setState({ reasonError: "Başvuru türü seçiniz" });
      return;
    }

    this.setState({
      currentStep: 2,
      reasonError: "",
      formAlert: null,
      ...this.getMissingPaymentInfoReset(),
    });
  };

  getMemberSelectOptions = () => toMemberSelectOptions(this.props.memberNumbers);

  setSelectError = (fieldId, errorId, message) => {
    if (message) {
      setCustomSelectFieldState(fieldId, true);
    } else {
      setCustomSelectFieldState(fieldId, false);
    }
  };

  validateMissingPaymentForm = () => {
    const {
      applicationType,
      wrongPaidMemberNo,
      targetMemberNo,
      paidMemberNo,
      dekontFile,
      missingPaymentConfirmed,
      paymentDate,
      paymentAmount,
    } = this.state;
    const errors = {
      kvkk: "",
      wrongPaidMemberNo: "",
      targetMemberNo: "",
      paidMemberNo: "",
      dekont: "",
      paymentDate: "",
      paymentAmount: "",
    };
    let isValid = true;

    if (applicationType === "1") {
      if (!wrongPaidMemberNo || wrongPaidMemberNo === "0") {
        errors.wrongPaidMemberNo = "Yanlış ödeme yapılan üye no boş bırakılamaz";
        this.setSelectError("yanlisOdemeUyeNo", "yanlisOdemeUyeNo_hatamesaj", errors.wrongPaidMemberNo);
        isValid = false;
      } else {
        this.setSelectError("yanlisOdemeUyeNo", "yanlisOdemeUyeNo_hatamesaj", "");
      }

      if (!targetMemberNo || targetMemberNo === "0") {
        errors.targetMemberNo = "Ödeme yapılmak istenen üye no boş bırakılamaz";
        this.setSelectError("hedefUyeNo", "hedefUyeNo_hatamesaj", errors.targetMemberNo);
        isValid = false;
      } else {
        this.setSelectError("hedefUyeNo", "hedefUyeNo_hatamesaj", "");
      }

      if (
        wrongPaidMemberNo &&
        targetMemberNo &&
        wrongPaidMemberNo !== "0" &&
        targetMemberNo !== "0" &&
        wrongPaidMemberNo === targetMemberNo
      ) {
        errors.targetMemberNo = "Üye numaraları birbirinden farklı olmalıdır";
        this.setSelectError("hedefUyeNo", "hedefUyeNo_hatamesaj", errors.targetMemberNo);
        isValid = false;
      }
    } else {
      if (!paidMemberNo || paidMemberNo === "0") {
        errors.paidMemberNo = "Ödeme yapılan üye no boş bırakılamaz";
        this.setSelectError("odemeYapilanUyeNo", "odemeYapilanUyeNo_hatamesaj", errors.paidMemberNo);
        isValid = false;
      } else {
        this.setSelectError("odemeYapilanUyeNo", "odemeYapilanUyeNo_hatamesaj", "");
      }
    }

    if (!paymentDate) {
      errors.paymentDate = "Ödeme tarihi boş bırakılamaz";
      isValid = false;
    } else if (paymentDate > getTodayDateInputValue()) {
      errors.paymentDate = "Ödeme tarihi ileri bir tarih olamaz";
      isValid = false;
    }

    const parsedAmount = Number(String(paymentAmount || "").replace(",", "."));
    if (!paymentAmount || Number.isNaN(parsedAmount) || parsedAmount <= 0) {
      errors.paymentAmount = "Tutar boş bırakılamaz";
      isValid = false;
    }

    if (!dekontFile) {
      errors.dekont = "Ödeme dekontu yüklemelisiniz";
      isValid = false;
    }

    if (!missingPaymentConfirmed) {
      errors.kvkk = "Devam etmek için onaylamalısınız";
      isValid = false;
    }

    this.setState({ formErrors: errors });
    return isValid;
  };

  applyDekontFile = (file) => {
    if (!file) {
      return;
    }

    if (!isAllowedDekontFile(file)) {
      this.setState({
        dekontFile: null,
        formErrors: {
          ...this.state.formErrors,
          dekont: "Yalnızca PDF, JPG veya PNG yükleyebilirsiniz",
        },
      });
      return;
    }

    if (file.size > DEKONT_MAX_BYTES) {
      this.setState({
        dekontFile: null,
        formErrors: {
          ...this.state.formErrors,
          dekont: "Dosya boyutu 10 MB'dan büyük olamaz",
        },
      });
      return;
    }

    this.setState({
      dekontFile: file,
      formErrors: {
        ...this.state.formErrors,
        dekont: "",
      },
    });
  };

  handleDekontInputChange = (event) => {
    const file = event.target.files && event.target.files[0];
    this.applyDekontFile(file);
    event.target.value = "";
  };

  handleDekontDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer?.files && event.dataTransfer.files[0];
    this.setState({ dekontDragOver: false });
    this.applyDekontFile(file);
  };

  goToPreviousStep = () => {
    if (this.isInfoStep() && isMissingPaymentReason(this.state.reason)) {
      this.goToTypeStep();
      return;
    }

    this.goToReasonStep();
  };

  submitFeedback = (memberNo, extra) => {
    this.setState({
      isProcessing: true,
      formErrors: {
        kvkk: "",
        wrongPaidMemberNo: "",
        targetMemberNo: "",
        paidMemberNo: "",
        dekont: "",
      },
      formAlert: null,
    });

    Promise.resolve(
      this.props.addFeedbacks(
        this.state.subject,
        this.state.description,
        this.state.reason,
        memberNo,

        this.state.nameSurname,
        this.state.tckn,
        this.state.fatherName,

        this.state.unvan,
        this.state.vkn,
        this.state.mersisNo,

        this.state.iban,
        this.state.phone,
        extra
      )
    )
      .then((result) => {
        if (result?.success === false) {
          const messages = toAlertMessages(result.message);
          if (messages.length > 0) {
            this.setState({
              formAlert: {
                type: "error",
                messages,
              },
            });
          }
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (this.state.currentStep === 0) {
      this.goToInfoStep();
      return;
    }

    if (this.isTypeStep()) {
      this.goToMissingPaymentInfoStep();
      return;
    }

    if (isMissingPaymentReason(this.state.reason)) {
      if (!this.validateMissingPaymentForm()) {
        return false;
      }

      const formData = new FormData();
      formData.append("basvuruTuru", this.state.applicationType);
      formData.append("yanlisOdemeYapilanUyeNo", this.state.applicationType === "1" ? this.state.wrongPaidMemberNo : "");
      formData.append("odemeYapilmakIstenenUyeNo", this.state.applicationType === "1" ? this.state.targetMemberNo : "");
      formData.append("odemeYapilanUyeNo", this.state.applicationType === "2" ? this.state.paidMemberNo : "");
      formData.append("aciklama", this.state.description || "");
      formData.append("islemTarihi", this.state.paymentDate);
      formData.append("tutar", String(this.state.paymentAmount || "").replace(",", "."));
      formData.append("izinOnayiDurum", this.state.missingPaymentConfirmed ? "true" : "false");
      if (this.state.dekontFile) {
        formData.append("file", this.state.dekontFile);
      }

      this.setState({
        isProcessing: true,
        formErrors: {
          kvkk: "",
          wrongPaidMemberNo: "",
          targetMemberNo: "",
          paidMemberNo: "",
          dekont: "",
          paymentDate: "",
          paymentAmount: "",
        },
        formAlert: null,
      });

      Promise.resolve(this.props.addOdemeUyumsuzlukTaleps(formData))
        .then((result) => {
          if (result?.success === false) {
            const messages = toAlertMessages(result.message);
            if (messages.length > 0) {
              this.setState({
                formAlert: {
                  type: "error",
                  messages,
                },
              });
            }
          }
        })
        .finally(() => {
          this.setState({ isProcessing: false });
        });
      return;
    }

    const kvkkError = !this.state.kvkkAccepted ? "Devam etmek için onaylamalısınız" : "";

    if (oneriFormKontrol(this.getReasonLabelForState()) === 0 || kvkkError) {
      this.setState({
        formErrors: {
          ...this.state.formErrors,
          kvkk: kvkkError,
        },
      });
      return false;
    }

    this.submitFeedback(this.state.memberNo);
  };

  clearFormAlert = () => {
    this.setState({ formAlert: null });
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentStep !== this.state.currentStep) {
      this.scrollToFormTop();
    }

    if (this.props.workflow?.addedFeedback && !prevProps.workflow?.addedFeedback) {
      this.setState({ currentStep: this.getResultStepIndex(), isProcessing: false });
      this.redirectTimeout = window.setTimeout(() => {
        this.props.clearSuccessMessage();
        this.props.history.push("/Home/MyDemands");
      }, 5000);
    }

    if (
      this.props.workflow?.feedbackErrorMessage &&
      prevProps.workflow?.feedbackErrorMessage !== this.props.workflow.feedbackErrorMessage
    ) {
      const messages = toAlertMessages(this.props.workflow.feedbackErrorMessage);
      this.setState({
        isProcessing: false,
        formAlert: messages.length
          ? {
              type: "error",
              messages,
            }
          : null,
      });
    }
  }

  getKvkk = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ isKvkkModalOpen: true });
  };

  handleKvkkLoaded = (kvkkMetni) => {
    this.setState({ kvkkMetni });
  };

  closeKvkkModal = () => {
    this.setState({ isKvkkModalOpen: false });
  };

  renderStaticInfoField = (label, icon, value) => (
    <div className="t-resetPassword-field">
      <span className="t-resetPassword-label">{label}</span>
      <div className="t-submitDemand-staticInfo">
        <i className={icon} aria-hidden="true" />
        <span>{value || "-"}</span>
      </div>
    </div>
  );

  renderFormField = (label, icon, control, errorId, htmlFor, errorMessage) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div className={`t-resetPassword-inputWrap t-submitDemand-inputWrap${errorMessage && String(errorMessage).trim() ? " t-error" : ""}`}>
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      <div className="t-icinputHatamesajArea t-resetPassword-error" id={errorId}>
        {errorMessage || ""}
      </div>
    </div>
  );

  renderTextareaField = (label, icon, control, errorId, htmlFor) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap t-submitDemand-inputWrap--textarea">
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      <div className="t-icinputHatamesajArea t-resetPassword-error" id={errorId} />
    </div>
  );

  getLoadingSubtext = () => {
    if (this.state.isProcessing) {
      return "Talebiniz gönderiliyor, lütfen bekleyiniz.";
    }

    if (this.props.isLoading) {
      return "Üyelik bilgileriniz hazırlanıyor, lütfen bekleyiniz.";
    }

    return "İşleminiz gerçekleştiriliyor, lütfen bekleyiniz.";
  };

  getStepTitle = () => {
    if (this.isResultStep()) return "Başvuru Sonucu";
    if (this.isTypeStep()) return "Başvuru Türü";
    if (this.isInfoStep()) return "Başvuru Bilgileri";
    return "Başvuru Nedeni Seçimi";
  };

  renderReasonChoices = () => {
    const { reason, reasonError } = this.state;
    const talepOptions = this.getTalepOptions();

    if (this.props.isLoadingDemandOptions) {
      return (
        <div className="t-createPayment-choiceSection">
          <EminevimLoading compact subtext="Başvuru nedenleri yükleniyor..." />
        </div>
      );
    }

    if (!talepOptions.length) {
      return (
        <div className="t-createPayment-choiceSection">
          <LoginPageAlert type="error" messages={["Başvuru nedenleri yüklenemedi. Lütfen sayfayı yenileyin."]} />
        </div>
      );
    }

    return (
      <div className="t-createPayment-choiceSection">
        <div className="t-submitDemand-typeBanner">
          <i className="t-icon-info2" aria-hidden="true" />
          <p>Talebinize uygun başvuru nedenini seçerek sonraki adıma devam edin.</p>
        </div>
        <div
          className={`t-smartCalculation-choiceGroup t-submitDemand-choiceGroup${
            reasonError ? " t-createPayment-choiceGroup--error" : ""
          }`}
        >
          {talepOptions.map((option) => (
            <label
              key={option.value}
              className={`t-smartCalculation-choiceCard ${option.cardClass}${
                option.showNewRibbon ? " t-submitDemand-choiceCard--new" : ""
              }`}
              htmlFor={option.inputId}
            >
              {option.showNewRibbon ? (
                <span className="t-salesDocNewRibbon" aria-hidden="true">YENİ</span>
              ) : null}
              <input
                type="radio"
                id={option.inputId}
                name="demandReason"
                value={option.value}
                className="t-smartCalculation-choiceInput"
                checked={reason === option.value}
                onChange={() => this.handleReasonChange(option.value)}
              />
              <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                <i className={option.iconClass} />
              </span>
              <span className="t-smartCalculation-choiceLabel">{option.label}</span>
              <span className="t-smartCalculation-choiceHint">{option.hint}</span>
            </label>
          ))}
        </div>
        {reasonError ? (
          <p className="t-resetPassword-error t-createPayment-choiceError">{reasonError}</p>
        ) : null}
      </div>
    );
  };

  renderTypeChoices = () => {
    const { applicationType, reasonError } = this.state;

    return (
      <div className="t-submitDemand-typeStep">
        <div className="t-submitDemand-typeBanner">
          <i className="t-icon-info2" aria-hidden="true" />
          <p>
            Hesaba geçmeyen ödemenizle ilgili size en uygun başvuru türünü seçerek devam edebilirsiniz.
          </p>
        </div>

        <h3 className="t-submitDemand-typeTitle">Başvuru Türünüzü Seçin</h3>

        <div className="t-submitDemand-typeList">
          {BASVURU_TURU_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`t-submitDemand-typeCard${
                applicationType === option.value ? " is-selected" : ""
              }`}
              onClick={() => this.selectApplicationType(option.value)}
            >
              <span className="t-submitDemand-typeCardIcon" aria-hidden="true">
                <i className={option.iconClass} />
              </span>
              <span className="t-submitDemand-typeCardBody">
                <strong>{option.title}</strong>
                <span>{option.hint}</span>
              </span>
              <i className="t-icon-arrow-right2 t-submitDemand-typeCardChevron" aria-hidden="true" />
            </button>
          ))}
        </div>
        {reasonError ? (
          <p className="t-resetPassword-error t-createPayment-choiceError">{reasonError}</p>
        ) : null}

        <div className="t-submitDemand-noteCard">
          <i className="t-icon-lightbulb" aria-hidden="true" />
          <div>
            <strong>Bilginiz Olsun</strong>
            <p>Talebiniz oluşturulduktan sonra süreci Talep Takibi ekranından takip edebilirsiniz.</p>
          </div>
        </div>

        <div className="t-submitDemand-noteCard t-submitDemand-noteCard--action">
          <i className="t-icon-office" aria-hidden="true" />
          <div>
            <strong>Yanlış Ödeme Yapmamak İçin</strong>
            <p>Banka bilgilerimizi inceleyerek ödemenizi doğru hesaba yaptığınızdan emin olun.</p>
          </div>
          <a
            className="t-memberInfo-btn t-memberInfo-btn--primary t-submitDemand-bankButton"
            href={BANK_INFO_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Banka Bilgilerimizi İncele</span>
            <i className="t-icon-arrow-right2" aria-hidden="true" />
          </a>
        </div>
      </div>
    );
  };

  renderMissingPaymentSelect = (label, id, errorId, value, onChange, errorMessage) => {
    const memberOptions = this.getMemberSelectOptions();

    return this.renderFormField(
      label,
      "t-icon-user",
      (
        <AppCustomSelect
          id={id}
          value={value}
          placeholder="Seçiniz"
          options={[
            { value: "0", label: "Seçiniz" },
            ...memberOptions,
          ]}
          onChange={onChange}
        />
      ),
      errorId,
      id,
      errorMessage
    );
  };

  renderDekontDropzone = () => {
    const { dekontFile, dekontDragOver, formErrors } = this.state;

    return (
      <div className="t-resetPassword-field">
        <label className="t-resetPassword-label" htmlFor="odemeDekontu">
          Ödeme Dekontu
        </label>
        <input
          id="odemeDekontu"
          ref={this.dekontInputRef}
          type="file"
          accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
          className="t-submitDemand-fileInput"
          onChange={this.handleDekontInputChange}
        />
        <div
          className={`t-submitDemand-dropzone${dekontDragOver ? " is-dragover" : ""}${
            formErrors.dekont ? " is-error" : ""
          }`}
          onClick={() => this.dekontInputRef.current && this.dekontInputRef.current.click()}
          onDragEnter={(event) => {
            event.preventDefault();
            this.setState({ dekontDragOver: true });
          }}
          onDragOver={(event) => event.preventDefault()}
          onDragLeave={() => this.setState({ dekontDragOver: false })}
          onDrop={this.handleDekontDrop}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              this.dekontInputRef.current && this.dekontInputRef.current.click();
            }
          }}
        >
          <i className="t-icon-cloud-upload" aria-hidden="true" />
          {dekontFile ? (
            <>
              <p>{dekontFile.name}</p>
              <small>Dosyayı değiştirmek için tıklayın veya sürükleyip bırakın</small>
            </>
          ) : (
            <>
              <p>Dosya seçin veya sürükleyip bırakın</p>
              <small>PDF, JPG, PNG (Maks. 10 MB)</small>
            </>
          )}
        </div>
        {formErrors.dekont ? (
          <div className="t-icinputHatamesajArea t-resetPassword-error">{formErrors.dekont}</div>
        ) : null}
      </div>
    );
  };

  renderMissingPaymentInfoFields = () => {
    const confirmText =
      this.state.applicationType === "1"
        ? "Yukarıda doldurduğum formun işleme alınmasını onaylıyorum."
        : "Yukarıda doldurduğum formun işleme alınmasını istiyorum.";
    const applicationTypeLabel =
      BASVURU_TURU_OPTIONS.find((option) => option.value === this.state.applicationType)?.title || "";

    return (
      <div className="t-submitDemand-missingPaymentForm">
        {this.renderStaticInfoField(
          "Başvuru Nedeni",
          "t-icon-file-text",
          this.getReasonLabelForState()
        )}

        {this.renderStaticInfoField(
          "Başvuru Türü",
          "t-icon-list",
          applicationTypeLabel
        )}

        {this.getMemberSelectOptions().length === 0 ? (
          <p className="t-resetPassword-error">Üyelik bulunamadı. Bu başvuru türü için üye numarası seçilemez.</p>
        ) : null}

        {this.state.applicationType === "1" ? (
          <>
            {this.renderMissingPaymentSelect(
              "Yanlış ödeme yapılan Üye No",
              "yanlisOdemeUyeNo",
              "yanlisOdemeUyeNo_hatamesaj",
              this.state.wrongPaidMemberNo,
              (nextValue) => {
                this.setSelectError("yanlisOdemeUyeNo", "yanlisOdemeUyeNo_hatamesaj", "");
                this.setState({
                  wrongPaidMemberNo: nextValue,
                  formErrors: { ...this.state.formErrors, wrongPaidMemberNo: "" },
                });
              },
              this.state.formErrors.wrongPaidMemberNo
            )}
            {this.renderMissingPaymentSelect(
              "Ödeme yapılmak istenen Üye No",
              "hedefUyeNo",
              "hedefUyeNo_hatamesaj",
              this.state.targetMemberNo,
              (nextValue) => {
                this.setSelectError("hedefUyeNo", "hedefUyeNo_hatamesaj", "");
                this.setState({
                  targetMemberNo: nextValue,
                  formErrors: { ...this.state.formErrors, targetMemberNo: "" },
                });
              },
              this.state.formErrors.targetMemberNo
            )}
          </>
        ) : (
          this.renderMissingPaymentSelect(
            "Ödeme yapılan Üye No",
            "odemeYapilanUyeNo",
            "odemeYapilanUyeNo_hatamesaj",
            this.state.paidMemberNo,
            (nextValue) => {
              this.setSelectError("odemeYapilanUyeNo", "odemeYapilanUyeNo_hatamesaj", "");
              this.setState({
                paidMemberNo: nextValue,
                formErrors: { ...this.state.formErrors, paidMemberNo: "" },
              });
            },
            this.state.formErrors.paidMemberNo
          )
        )}

        {this.renderFormField(
          "Ödeme Tarihi",
          "t-icon-calendar",
          (
            <input
              type="date"
              id="odemeTarihi"
              name="odemeTarihi"
              max={getTodayDateInputValue()}
              value={this.state.paymentDate}
              onChange={(e) => {
                const nextValue = e.target.value;
                const today = getTodayDateInputValue();
                if (nextValue && nextValue > today) {
                  this.setState({
                    paymentDate: "",
                    formErrors: {
                      ...this.state.formErrors,
                      paymentDate: "Ödeme tarihi ileri bir tarih olamaz",
                    },
                  });
                  return;
                }
                this.setState({
                  paymentDate: nextValue,
                  formErrors: { ...this.state.formErrors, paymentDate: "" },
                });
              }}
            />
          ),
          "odemeTarihi_hatamesaj",
          "odemeTarihi",
          this.state.formErrors.paymentDate
        )}

        {this.renderFormField(
          "Tutar",
          "t-icon-banknote",
          (
            <input
              type="text"
              inputMode="decimal"
              autoComplete="off"
              id="odemeTutari"
              name="odemeTutari"
              placeholder="0,00"
              value={this.state.paymentAmount}
              onChange={(e) => {
                const nextValue = e.target.value.replace(/[^0-9.,]/g, "");
                const wrap = e.target.closest(".t-resetPassword-inputWrap");
                if (wrap) {
                  wrap.classList.remove("t-error");
                }
                this.setState((prev) => ({
                  paymentAmount: nextValue,
                  formErrors: {
                    ...prev.formErrors,
                    paymentAmount: "",
                  },
                }));
              }}
            />
          ),
          "odemeTutari_hatamesaj",
          "odemeTutari",
          this.state.formErrors.paymentAmount
        )}

        {this.renderDekontDropzone()}

        <div className="t-resetPassword-field">
          <label htmlFor="mesaj" className="t-resetPassword-label">
            Açıklama (İsteğe bağlı)
          </label>
          <div className="t-submitDemand-textareaBox">
            <textarea
              id="mesaj"
              name="mesaj"
              rows="4"
              maxLength={DESCRIPTION_MAX_LENGTH}
              value={this.state.description}
              onChange={(e) => this.setState({ description: e.target.value })}
              placeholder="Açıklamanızı buraya yazabilirsiniz..."
            />
            <span className="t-submitDemand-charCount">
              {this.state.description.length} / {DESCRIPTION_MAX_LENGTH}
            </span>
          </div>
        </div>

        <div
          className={`t-submitDemand-kvkk${
            this.state.formErrors.kvkk ? " t-submitDemand-kvkk--error" : ""
          }`}
        >
          <input
            type="checkbox"
            className="t-kvkkcheckbox"
            id="onaychecked"
            checked={this.state.missingPaymentConfirmed}
            onChange={(e) => {
              this.setState({
                missingPaymentConfirmed: e.target.checked,
                formErrors: { ...this.state.formErrors, kvkk: "" },
              });
            }}
          />
          <span className="t-submitDemand-kvkkText">{confirmText}</span>
        </div>
        {this.state.formErrors.kvkk ? (
          <p className="t-resetPassword-error t-submitDemand-kvkkError">
            {this.state.formErrors.kvkk}
          </p>
        ) : null}
      </div>
    );
  };

  renderInfoFields = () => {
    if (isMissingPaymentReason(this.state.reason)) {
      return this.renderMissingPaymentInfoFields();
    }

    return (
    <>
      {(this.state.reason === "5" || this.state.reason === "6") &&
        Array.isArray(this.props.memberFek) &&
        this.props.memberFek.length > 0 &&
        this.renderFormField(
          "Üyelik Bilgisi",
          "t-icon-user",
          (
            <AppCustomSelect
              id="uyeNo"
              value={this.state.memberNo}
              placeholder="Seçiniz"
              options={[
                { value: "0", label: "Seçiniz" },
                ...this.props.memberFek.map((item) => ({
                  value: String(item.id),
                  label: item.adi,
                })),
              ]}
              onChange={(nextValue) => this.setState({ memberNo: nextValue })}
            />
          ),
          "uyeNo_hatamesaj",
          "uyeNo"
        )}

      {this.renderFormField(
        "Konu",
        "t-icon-pen1",
        (
          <input
            type="text"
            id="konu"
            name="konu"
            placeholder="Konu başlığınızı yazınız"
            required
            maxLength="200"
            value={this.state.subject}
            readOnly={this.state.isSubjectReadonly}
            onChange={(e) => {
              this.setState({ subject: e.target.value });
            }}
          />
        ),
        "konu_hatamesaj",
        "konu"
      )}

      {this.state.reason === "7" && (
        <div className="t-submitDemand-section">
          {this.renderFormField(
            "Üyelik Bilgisi",
            "t-icon-user",
            (
              <AppCustomSelect
                id="uyeNoIban"
                value={this.state.memberNo}
                placeholder="Seçiniz"
                options={[
                  { value: "0", label: "Seçiniz" },
                  ...(Array.isArray(this.props.memberIban) ? this.props.memberIban : []).map((item) => ({
                    value: String(item.id),
                    label: item.adi,
                  })),
                ]}
                onChange={(nextValue) => this.setState({ memberNo: nextValue })}
              />
            ),
            "uyeNoIban_hatamesaj",
            "uyeNoIban"
          )}

          {this.renderFormField(
            "Satıcı Türü",
            "t-icon-lock1",
            (
              <AppCustomSelect
                id="saticiTuru"
                value={this.state.saticiTuru}
                placeholder="Seçiniz"
                options={[
                  { value: "0", label: "Seçiniz" },
                  { value: "1", label: "Bireysel" },
                  { value: "2", label: "Kurumsal" },
                ]}
                onChange={(nextValue) => this.setState({ saticiTuru: nextValue })}
              />
            ),
            "saticiTuru_hatamesaj",
            "saticiTuru"
          )}

          {this.state.saticiTuru === "1" && (
            <>
              {this.renderFormField(
                "Satıcı Adı Soyadı",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="adiSoyadi"
                    name="adiSoyadi"
                    placeholder="Satıcı adı soyadı yazınız"
                    required
                    maxLength="200"
                    value={this.state.nameSurname}
                    onChange={(e) => {
                      this.setState({ nameSurname: e.target.value });
                    }}
                  />
                ),
                "adiSoyadi_hatamesaj",
                "adiSoyadi"
              )}

              {this.renderFormField(
                "Satıcı TC Kimlik No",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="tckn"
                    name="tckn"
                    placeholder="Satıcı TC kimlik no yazınız"
                    required
                    maxLength="11"
                    value={this.state.tckn}
                    onChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                      this.setState({ tckn: onlyNumbers });
                    }}
                  />
                ),
                "tckn_hatamesaj",
                "tckn"
              )}

              {this.renderFormField(
                "Satıcı Baba Adı",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="babaAdi"
                    name="babaAdi"
                    placeholder="Satıcı baba adını yazınız"
                    required
                    maxLength="200"
                    value={this.state.fatherName}
                    onChange={(e) => {
                      this.setState({ fatherName: e.target.value });
                    }}
                  />
                ),
                "babaAdi_hatamesaj",
                "babaAdi"
              )}
            </>
          )}

          {this.state.saticiTuru === "2" && (
            <>
              {this.renderFormField(
                "Satıcı Ünvan",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="unvan"
                    name="unvan"
                    placeholder="Satıcı ünvanı yazınız"
                    required
                    maxLength="500"
                    value={this.state.unvan}
                    onChange={(e) => {
                      this.setState({ unvan: e.target.value });
                    }}
                  />
                ),
                "unvan_hatamesaj",
                "unvan"
              )}

              {this.renderFormField(
                "Satıcı VKN",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="vkn"
                    name="vkn"
                    placeholder="Satıcı VKN yazınız"
                    required
                    maxLength="10"
                    value={this.state.vkn}
                    onChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                      this.setState({ vkn: onlyNumbers });
                    }}
                  />
                ),
                "vkn_hatamesaj",
                "vkn"
              )}

              {this.renderFormField(
                "Satıcı Mersis No",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="mersisNo"
                    name="mersisNo"
                    placeholder="Satıcı Mersis No yazınız"
                    required
                    maxLength="16"
                    value={this.state.mersisNo}
                    onChange={(e) => {
                      this.setState({ mersisNo: e.target.value });
                    }}
                  />
                ),
                "mersisNo_hatamesaj",
                "mersisNo"
              )}
            </>
          )}

          {(this.state.saticiTuru === "1" || this.state.saticiTuru === "2") && (
            <>
              {this.renderFormField(
                "Satıcı Tel No",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder="Satıcı tel no"
                    required
                    maxLength="10"
                    value={this.state.phone}
                    onChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                      this.setState({ phone: onlyNumbers });
                    }}
                  />
                ),
                "phone_hatamesaj",
                "phone"
              )}

              {this.renderFormField(
                "Satıcı IBAN",
                "t-icon-pen1",
                (
                  <input
                    type="text"
                    id="iban"
                    name="iban"
                    placeholder="TR ---- ---- ---- ---- ---- ----"
                    required
                    maxLength="32"
                    value={this.state.iban}
                    onChange={(e) => {
                      let raw = e.target.value.toUpperCase();
                      raw = raw.replace(/^TR?/, "");
                      raw = raw.replace(/[^0-9]/g, "");
                      raw = raw.slice(0, 24);
                      let formatted = "TR" + raw;
                      formatted = formatted.match(/.{1,4}/g)?.join(" ") || "";
                      this.setState({ iban: formatted });
                    }}
                  />
                ),
                "iban_hatamesaj",
                "iban"
              )}
            </>
          )}
        </div>
      )}

      {this.state.reason !== "7" &&
        this.renderTextareaField(
          "Açıklama",
          "t-icon-bubble1",
          (
            <textarea
              className="form-control"
              id="mesaj"
              name="mesaj"
              rows="3"
              required
              maxLength="1000"
              value={this.state.description}
              onChange={(e) => {
                this.setState({ description: e.target.value });
              }}
              placeholder="Mesajınızı yazınız"
            />
          ),
          "mesaj_hatamesaj",
          "mesaj"
        )}

      <div
        className={`t-submitDemand-kvkk${
          this.state.formErrors.kvkk ? " t-submitDemand-kvkk--error" : ""
        }`}
      >
        <input
          type="checkbox"
          className="t-kvkkcheckbox"
          id="onaychecked"
          checked={this.state.kvkkAccepted}
          onChange={(e) => {
            this.setState({
              kvkkAccepted: e.target.checked,
              formErrors: { kvkk: "" },
            });
          }}
        />
        <span className="t-submitDemand-kvkkText">
          <a id="kvkk-onayla" href="#kvkk-onayla" onClick={this.getKvkk}>
            KVKK Taahhütnamesi
          </a>
          &apos;ni <strong>ONAYLIYORUM</strong>
        </span>
      </div>
      {this.state.formErrors.kvkk ? (
        <p className="t-resetPassword-error t-submitDemand-kvkkError">
          {this.state.formErrors.kvkk}
        </p>
      ) : null}
    </>
    );
  };

  renderResult = () => (
    <div className="t-infoSuccess-body">
      <div className="t-infoSuccess-icon">
        <i className="t-icon-checkmark" aria-hidden="true" />
      </div>
      <h2 className="t-infoSuccess-title">Talebiniz başarıyla oluşturuldu. Talep Takibi sayfasına yansıması birkaç dakika sürebilmektedir.</h2>
      <p className="t-infoSuccess-message">
        Talebiniz ile ilgili gelişmeleri &apos;Talep Takibi&apos; menüsünden takip edebilirsiniz.
      </p>
      <p className="t-infoSuccess-redirect">Birkaç saniye içinde yönlendirileceksiniz...</p>
      <div className="t-infoSuccess-actions">
        <Link
          to="/Home/MyDemands"
          className="t-memberInfo-btn t-memberInfo-btn--primary"
          onClick={() => {
            if (this.redirectTimeout) {
              window.clearTimeout(this.redirectTimeout);
            }
            this.props.clearSuccessMessage();
          }}
        >
          <span>Talep Takibine Git</span>
          <i className="t-icon-arrow-right2" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );

  render() {
    const { isLoading } = this.props;
    const { shouldAnimateCard, isProcessing, currentStep, reason } = this.state;
    const demandSteps = this.getDemandSteps();
    const isResultStep = this.isResultStep();
    const isTypeStep = this.isTypeStep();
    const isInfoStep = this.isInfoStep();
    const showLoadingOverlay = !isResultStep && (isProcessing || isLoading);
    const reasonLabel = this.getReasonLabelForState(reason);
    const submitLabel =
      currentStep === 0 || isTypeStep
        ? "Devam"
        : isMissingPaymentReason(reason)
          ? "Talep Oluştur"
          : "Mesajımı Gönder";
    const showBackButton = isTypeStep || isInfoStep;
    const showSubmitButton = true;

    const renderStepContent = () => {
      if (currentStep === 0) {
        return this.renderReasonChoices();
      }
      if (isTypeStep) {
        return this.renderTypeChoices();
      }
      return this.renderInfoFields();
    };

    return (
      <div className="t-submitDemand-page" style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Öneri ve İstekleriniz</h1>
              <p className="t-memberInfo-pageSubtitle">
                Öneri, talep veya şikayetlerinizi iletebilir; fek ve IBAN işlemlerinizi buradan başlatabilirsiniz.
              </p>
            </div>

            <article
              className={`t-memberInfo-card t-memberDetail-header--green${
                shouldAnimateCard ? " t-memberInfo-card--enter" : ""
              }`}
            >
              <div className="t-memberInfo-cardHeader">
                <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                  <i className="t-icon-bubble1" aria-hidden="true" />
                </div>
                <div className="t-memberInfo-cardHeaderContent">
                  <div className="t-memberInfo-cardTitleRow">
                    <h2 className="t-memberInfo-cardTitle">{this.getStepTitle()}</h2>
                    {reasonLabel ? (
                      <span className="t-memberInfo-typeChip">{reasonLabel}</span>
                    ) : null}
                  </div>
                  <div className="t-memberInfo-cardBadges">
                    <span className="t-memberDetail-headerBadge">
                      Adım {currentStep + 1} / {demandSteps.length}
                    </span>
                  </div>
                </div>
              </div>

              {renderDemandSteps(currentStep, demandSteps)}

              {isResultStep ? (
                this.renderResult()
              ) : (
                <form
                  className="t-resetPassword-form t-submitDemand-form"
                  onSubmit={this.onSubmit}
                  noValidate
                >
                  {this.state.formAlert ? (
                    <LoginPageAlert
                      messages={this.state.formAlert.messages}
                      type={this.state.formAlert.type}
                      onDismiss={this.clearFormAlert}
                    />
                  ) : null}

                  {renderStepContent()}

                  <div className={`t-eminPayOrder-formActions${
                    isMissingPaymentReason(reason) && isInfoStep ? " t-submitDemand-formActions--start" : ""
                  }`}>
                    {showBackButton ? (
                      <button
                        type="button"
                        className="t-memberInfo-btn t-memberInfo-btn--secondary"
                        onClick={this.goToPreviousStep}
                        disabled={showLoadingOverlay}
                      >
                        <i className="t-icon-arrow-left2" aria-hidden="true" />
                        <span>Geri</span>
                      </button>
                    ) : null}
                    {showSubmitButton ? (
                      <button
                        type="submit"
                        className={`t-memberInfo-btn t-memberInfo-btn--primary${
                          isMissingPaymentReason(reason) && isInfoStep ? " t-submitDemand-createButton" : ""
                        }`}
                        disabled={showLoadingOverlay}
                      >
                        <span>{submitLabel}</span>
                        <i className="t-icon-arrow-right2" aria-hidden="true" />
                      </button>
                    ) : null}
                  </div>
                </form>
              )}
            </article>
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />

        <KvkkModal
          isOpen={this.state.isKvkkModalOpen}
          onClose={this.closeKvkkModal}
          onLoaded={this.handleKvkkLoaded}
        />

        {showLoadingOverlay && (
          <div className="t-eminevimLoadingOverlay">
            <EminevimLoading subtext={this.getLoadingSubtext()} compact />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workflow: selectWorkflow(state),
    memberFek: state.workflow.memberFek,
    memberIban: state.workflow.memberIban,
    submitDemandOptions: state.workflow.submitDemandOptions || [],
    isLoadingDemandOptions: state.workflow.isLoadingDemandOptions || false,
    memberNumbers: state.member?.numbers || [],
    isLoading: state.workflow.isLoading || false
  };
};

const mapDispatchToProps = (dispatch) => ({
  addFeedbacks: (subject, description, reason, memberNo, nameSuranme, tckn, fatherName, unvan, vkn, mersisNo, iban, phone, extra) =>
    dispatch(addFeedbacks(subject, description, reason, memberNo, nameSuranme, tckn, fatherName, unvan, vkn, mersisNo, iban, phone, extra)),
  addOdemeUyumsuzlukTaleps: (formData) => dispatch(addOdemeUyumsuzlukTaleps(formData)),
  getSubmitDemandOptions: () => dispatch(getSubmitDemandOptions()),
  getMemberFeks: (orgTuru) => dispatch(getMemberFeks(orgTuru)),
  getMemberIbans: () => dispatch(getMemberIbans()),
  getMemberNumber: () => dispatch(getMemberNumber()),
  clearMemberFek: () => dispatch(clearMemberFek()),
  clearMemberIban: () => dispatch(clearMemberIban()),
  clearSuccessMessage: () => dispatch(clearSuccessMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubmitDemand));
